<template>
    <div ref="targetElement">
<!--        <div v-if="location === 'home'" class="info-banner d-flex justify-content-center gap-2">-->
<!--            <img src="/img/icons/forbidden.svg" alt="img-forbidden">-->
<!--            <p class="text-bat fs-7 text-left text-md-start">-->
<!--                Material dirigido al canal de comercialización. Prohibida su reproducción total o parcial.-->
<!--            </p>-->
<!--        </div>-->

        <legal-disclaimer v-if="location === 'home' && showDiv" :is_client_seller="false" :style="{ top: headerHeight + 'px' }"></legal-disclaimer>

        <div :class="location !== 'redeem' ? 'px-2 px-lg-5' : ''" class="mt-3 mb-3 mt-lg-4">
            <slick v-if="banners.length" ref="slick" :options="slickOptionsBanner" class="slick-vue mb-2">
                <div v-for="(banner, index) in banners" :key="index" v-if="index < 8"  class="px-1 px-lg-4 position-relative">
                    <div :title="banner.title" :id="'top-banner-' + (index+1)" class="d-flex justify-content-center w-100">
                        <img v-if="$mq !== 'sm' && banner.image" :src="banner.image" :alt="banner.title" class="rounded-4 w-100">
                        <img v-else-if="$mq === 'sm' && banner.mobile_image" :src="banner.mobile_image" :alt="banner.title" class="rounded-4 w-100">
                    </div>
                    <div v-if="banner.has_button == 1" class="position-absolute w-100 text-center" :style="$mq === 'sm' ? 'bottom: 30px;' : 'bottom: 55px'">
                        <a :href="banner.link" :target="banner.target" class="mx-1 btn btn-warning text-title-bat rounded-3" style="background-color: #ff8e01;">
                            {{ banner.button_text }}
                        </a>
                    </div>
                </div>
            </slick>
        </div>
    </div>
</template>

<script>
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
export default {
    components: { Slick },
    props: {
        location: {
            default: 'home',
        },
    },
    data() {
        return {
            loading: 0,
            banners: [],
            slickOptionsBanner: {
                dots: true,
                arrows: false,
                infinite: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1150,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            },
            headerHeight: 0,
            showDiv: true,
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
        this.loadBanners();
        const header = document.getElementById('header-bat');
        if (header) {
            this.headerHeight = header.offsetHeight;
        }
        window.addEventListener('resize', this.updateHeaderHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateHeaderHeight);
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        loadBanners(){
            this.loading++
            axios.get(`load-new-banners?location=${this.location}`)
            .then(({data}) => {
                this.banners = data.banners
                this.loading--
            })
        },
        updateHeaderHeight() {
            const header = document.getElementById('header-bat');
            if (header) {
                this.headerHeight = header.offsetHeight;
            }
        },
        handleScroll() {
            const offset = 100;
            const targetElementPosition = this.$refs.targetElement.offsetTop - offset;
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            this.showDiv = scrollPosition >= targetElementPosition;
        },
    }
}
</script>
